/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import { getConfig } from './utils';

export const ROBO_URL = getConfig('ROBO_URL') || '';

export const navs = [
  {
    key: 'home',
    url: ROBO_URL, // Replace /v2 for root(/) as home page url. Only work on dev & stg & prod
    text: '首页',
  },
  {
    key: 'landing/secpool_private',
    url: `${ROBO_URL}/landing/secpool_private`,
    text: '自选',
    children: [
      {
        key: 'landing/secpool_private',
        url: '/landing/secpool_private',
        text: '自选股票',
      },
      {
        key: 'discovery/news',
        url: '/discovery/news',
        text: '新闻',
      },
      {
        key: 'discovery/announcement',
        url: '/discovery/announcement',
        text: '公告',
      },
    ],
  },
  {
    key: 'report',
    url: `${ROBO_URL}/selection`,
    text: '研报',
    children: [
      {
        key: 'selection',
        url: '/selection',
        text: '研报精选',
      },
      {
        key: 'fastreport',
        url: '/fastreport',
        text: '快看研报',
      },
      {
        key: 'landing/analyst_expect',
        url: '/landing/analyst_expect',
        text: '分析师预期',
      },
      {
        key: 'headline',
        url: '/headline',
        text: '深度见闻',
      },
      {
        key: 'upload',
        url: '/upload',
        text: '上传研报',
      },
    ],
  },
  {
    key: 'data',
    url: `${ROBO_URL}/landing/indicator_library`,
    text: '数据',
    children: [
      {
        key: 'landing/indicator_library',
        url: '/landing/indicator_library',
        text: '指标库',
      },
      {
        key: 'landing/macrogrp',
        url: '/landing/macrogrp',
        text: '宏观经济',
      },
      {
        key: 'landing/industrygrp',
        url: '/landing/industrygrp',
        text: '行业经济',
      },
      {
        key: 'landing/marketgrp',
        url: '/landing/marketgrp',
        text: '市场统计',
      },
      {
        key: 'landing/mygrp',
        url: '/landing/mygrp',
        text: '数据监控',
      },
    ],
  },
  {
    key: 'research',
    url: `${ROBO_URL}/landing/peband`,
    text: '研究',
    children: [
      {
        key: 'landing/peband',
        url: '/landing/peband',
        text: 'PE/PB Bands	',
      },
      {
        key: 'landing/peer_comparison',
        url: '/landing/peer_comparison',
        text: '同类对比',
      },
      {
        key: 'research/finance',
        url: '/research/finance',
        text: '财务分析',
      },
      {
        key: 'landing/strategystock',
        url: '/landing/strategystock',
        text: '策略选股',
      },
      {
        key: 'macro_forecast',
        url: '/macro_forecast',
        text: '大盘预测',
      },
      {
        key: 'datacenter/research',
        url: getConfig('rrp_url', '/v1.5/datacenter/research'),
        text: '投研框架',
      },
      {
        key: 'industry',
        exact: true,
        url: '/industry',
        text: '行业分析',
      },
      {
        key: 'stock/relation',
        url: getConfig('rrp_url', '/v1.5/stock/relation/index'),
        text: '关系图谱',
      },
    ],
  },
  {
    key: 'dashboard',
    url: `${ROBO_URL}/dashboard`,
    text: '看板',
  },
  {
    key: 'navigation',
    url: `${ROBO_URL}/navigation`,
    text: '更多',
  },
];
